import { render, staticRenderFns } from "./projectBoard.vue?vue&type=template&id=069d4597&scoped=true"
import script from "./projectBoard.vue?vue&type=script&lang=js"
export * from "./projectBoard.vue?vue&type=script&lang=js"
import style0 from "./projectBoard.vue?vue&type=style&index=0&id=069d4597&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d4597",
  null
  
)

export default component.exports